import React from "react";
import { Create } from "react-admin";
import { useTranslate } from "react-admin";
import RulesForm from "./RulesForm";
import { transformData } from "./Services/rulesServices";

const RulesCreate: React.FC = () => {
  const translate = useTranslate();

  return (
    <Create
      title={translate("rules.create.title")}
      redirect="list"
      transform={transformData}
    >
      <RulesForm />
    </Create>
  );
};

export default RulesCreate;
